import { render, staticRenderFns } from "./requisiteArchive.vue?vue&type=template&id=f839bab2"
import script from "./requisiteArchive.vue?vue&type=script&lang=js"
export * from "./requisiteArchive.vue?vue&type=script&lang=js"
import style0 from "./requisiteArchive.vue?vue&type=style&index=0&id=f839bab2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports